import { render, staticRenderFns } from "./globalSetting.vue?vue&type=template&id=7307efba&scoped=true"
import script from "./globalSetting.vue?vue&type=script&lang=js"
export * from "./globalSetting.vue?vue&type=script&lang=js"
import style0 from "./globalSetting.vue?vue&type=style&index=0&id=7307efba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7307efba",
  null
  
)

export default component.exports